var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrustTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.1811C14 14.9765 14.9765 14 16.1811 14H72.8901C74.0947 14 75.0712 14.9765 75.0712 16.1811V53.2601C75.0712 54.4646 74.0947 55.4412 72.8901 55.4412H16.1811C14.9765 55.4412 14 54.4646 14 53.2601V16.1811ZM18.3622 18.3622V51.0789H70.709V18.3622H18.3622Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5356 51.0789C45.2649 51.0789 45.9459 51.4433 46.3504 52.0501L59.4371 71.6801C60.1053 72.6824 59.8344 74.0366 58.8322 74.7048C57.8299 75.373 56.4757 75.1021 55.8075 74.0999L44.5356 57.192L33.2637 74.0999C32.5955 75.1021 31.2413 75.373 30.2391 74.7048C29.2368 74.0366 28.9659 72.6824 29.6341 71.6801L42.7208 52.0501C43.1253 51.4433 43.8063 51.0789 44.5356 51.0789Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7241 24.9057C22.7241 23.7011 23.7006 22.7246 24.9052 22.7246H37.9919C39.1965 22.7246 40.173 23.7011 40.173 24.9057C40.173 26.1103 39.1965 27.0868 37.9919 27.0868H24.9052C23.7006 27.0868 22.7241 26.1103 22.7241 24.9057ZM22.7241 33.6302C22.7241 32.4256 23.7006 31.4491 24.9052 31.4491H37.9919C39.1965 31.4491 40.173 32.4256 40.173 33.6302C40.173 34.8348 39.1965 35.8113 37.9919 35.8113H24.9052C23.7006 35.8113 22.7241 34.8348 22.7241 33.6302ZM22.7241 42.3546C22.7241 41.15 23.7006 40.1735 24.9052 40.1735H37.9919C39.1965 40.1735 40.173 41.15 40.173 42.3546C40.173 43.5592 39.1965 44.5358 37.9919 44.5358H24.9052C23.7006 44.5358 22.7241 43.5592 22.7241 42.3546Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4412 27.0868C51.8274 27.0868 48.8979 30.0164 48.8979 33.6302C48.8979 37.244 51.8274 40.1735 55.4412 40.1735C59.055 40.1735 61.9846 37.244 61.9846 33.6302C61.9846 30.0164 59.055 27.0868 55.4412 27.0868ZM44.5356 33.6302C44.5356 27.6072 49.4182 22.7246 55.4412 22.7246C61.4642 22.7246 66.3468 27.6072 66.3468 33.6302C66.3468 39.6532 61.4642 44.5358 55.4412 44.5358C49.4182 44.5358 44.5356 39.6532 44.5356 33.6302Z",
    fill: "#BAE047",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustTemplate);
export default __webpack_public_path__ + "static/media/trust-template.8273556ff04fa076a6968219651d87e0.svg";
export { ForwardRef as ReactComponent };